import { MdOutlineDocumentScanner, MdOutlineSummarize, MdHistory } from 'react-icons/md';
import { PiSealPercentBold } from "react-icons/pi";
import { LiaCoinsSolid } from "react-icons/lia";


export const navLinks = [
    {
        title: "Estrazione F24",
        icon: <MdOutlineDocumentScanner className='icon' />,
        url: "/f24-extraction",
        description: "Estrai e converti i moduli F24",
    },
    {
        title: "Registri IVA Marelli",
        icon: <PiSealPercentBold className='icon' />,
        url: "/marelli-registri-iva",
        description: "Inizia la rendicontazione IVA",
    },
    {
        title: "Lettura DM10",
        icon: <LiaCoinsSolid className='icon' />,
        url: "/dm10-reading",
        description: "Estrai dati anagrafici e saldo",
    },
    {
        title: "Riepilogo F24",
        icon: <MdOutlineSummarize className='icon' />,
        url: "/f24-summarize",
        description: "Riepiloga i versamenti",
    },
    {
        title: "Portale Legacy",
        icon: <MdHistory className='icon' />,
        url: "/legacy",
        description: "Accedi alla versione legacy del portale FatturaMI",
        legacy: true,
    }
];
